import { faEdit, faSync, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import { useParams } from "react-router-dom";
import EditChartOfAccounting from "../EditChartOfAccounting";
import AccountingDelete from "./AccountingDelete";
import CustomTooltip from "../../../common/CustomTooltip";

const AccountingActionButton = ({
  id,
  handleDelete,
  fetchAccountData,
  ProjectReadOnly,
  toggleSingleSyncOptionModal,
  xeroConnection,
  isUsed,
  disableParent,
  childNodes,
  limit,
  page,
}) => {
  const [showDelete, setShowDelete] = useState(false);
  const [showAccount, setShowAccount] = useState(false);
  const params = useParams();
  const projectId = params?.project_id;

  const toggleDeleteModal = () => {
    setShowDelete(!showDelete);
  };

  const toggleAccountModal = () => {
    setShowAccount(!showAccount);
  };

  return (
    <>
      <span>
        <CustomTooltip message={"Edit"}>
          <span>
            <FontAwesomeIcon
              icon={faEdit}
              size="1x"
              onClick={toggleAccountModal}
              data-toggle="modal"
              data-target="#account"
            />
          </span>
        </CustomTooltip>
        {!ProjectReadOnly &&
          isUsed === 0 &&
          disableParent === false &&
          childNodes?.length === 0 && (
            <>
              <span></span>&nbsp;&nbsp;/&nbsp;&nbsp;
              <FontAwesomeIcon
                onClick={toggleDeleteModal}
                icon={faTrash}
                size="1x"
                data-toggle="modal"
                data-target="#deleteAccount"
              />
            </>
          )}
      </span>
      {!ProjectReadOnly &&
        (xeroConnection ? (
          <>
            <span></span>&nbsp;&nbsp;/&nbsp;&nbsp;
            <CustomTooltip message={"Sync"}>
              <span>
                <FontAwesomeIcon
                  icon={faSync}
                  size="1x"
                  onClick={() => toggleSingleSyncOptionModal(id)}
                />
              </span>
            </CustomTooltip>
          </>
        ) : (
          <>
            <span></span>&nbsp;&nbsp;/&nbsp;&nbsp;
            <CustomTooltip message={"Please connect with xero to sync."}>
              <span>
                <FontAwesomeIcon
                  icon={faSync}
                  size="1x"
                  className="disabled-font-awesome"
                  disabled
                  onClick={() => toggleSingleSyncOptionModal(id)}
                />
              </span>
            </CustomTooltip>
          </>
        ))}

      {showDelete && (
        <AccountingDelete
          accountingId={id}
          toggleDeleteModal={toggleDeleteModal}
          handleDelete={handleDelete}
          showDelete={showDelete}
        />
      )}
      {showAccount && (
        <EditChartOfAccounting
          accountingId={id}
          projectId={projectId}
          toggleAccountModal={toggleAccountModal}
          fetchAccountData={fetchAccountData}
          showAccount={showAccount}
          limit={limit}
          page={page}
        />
      )}
    </>
  );
};

export default AccountingActionButton;
